import { AxiosRequest } from '@infrastructure/axios';
import { IUserService, User ,BankData } from '../../types';
import {Invoice } from '@core/domain/Invoice/types';

export default class UserService implements IUserService {
  async getProfile(controller: AbortController): Promise<User> {
    const res = await AxiosRequest.get<User>(`/profile`, { signal: controller.signal });
    return res.data.data;
  }

  async getUserBankInfo(controller: AbortController): Promise<BankData> {
    const response = await AxiosRequest.get<BankData>(`/profile/bank-info`, { signal: controller.signal });
    return response.data.data;
  }

  async getUserLastFiveInvoice(controller:AbortController) : Promise<Invoice[]>{
    const response = await AxiosRequest.get<Invoice[]>('/profile/stats',{signal:controller.signal});
    return response.data.data
  }

}
